import React, { useEffect, useState } from "react";

import { Button, Skeleton } from "antd";

import {
  // ResourcesWrapper,
  default as useApiHook,
} from "./assets/api/UseAxios";

import HeaderSlider from "./HeaderSlider";

import { Wrapper } from "./Notes";
import FileUpload from "./assets/file-upload/FileUpload";
import FilePreview from "./assets/file-upload/FilePreview";

const Container = ({ fetchedData, loading }: any) => {
  const [selectedType] = useState("inspection");
  const [fileResourcesState, setFileResourcesState] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState("Photos");

  const files = fetchedData?.data ?? [];
  const detailsId = files?.[0]?.item_id;

  useEffect(() => {
    setFileResourcesState(files);
  }, [files]);

  const { fetchData: bindResource, loading: bindLoading } = useApiHook({
    endpoint: `s3/bind-resource_by_pass/`,
    method: "POST",
  });

  const { fetchData: deleteResource } = useApiHook({
    endpoint: `s3/update-resource_by_pass/`,
    method: "PUT",
  });

  const handleDelete = async (file_reference: string) => {
    const damageId = detailsId ? parseInt(detailsId, 10) : 0;

    const filteredFiles = fileResourcesState?.filter((file) => file.file_reference === file_reference);

    if (!filteredFiles.length) {
      setFileResourcesState((prev) => prev.filter((file) => file.download !== file_reference));
      return;
    }

    const payload = filteredFiles.map((fileData) => ({
      ...fileData,
      file_type: fileData?.file_types?.types,
      damage_id: damageId,
      is_deleted: true,
      vehicle_defect_resolution_id: damageId,
    }));

    await deleteResource({ payload, endPointQuery: `?resource_type=${"defect"}` });
  };

  const handleSave = async () => {
    const newFiles = fileResourcesState.filter((f) => f.download !== undefined);
    if (!newFiles.length) return;

    const damageId = detailsId ? parseInt(detailsId, 10) : 0;

    const payload = newFiles.map(({ download, ...fileData }) => ({
      ...fileData,
      file_type: fileData?.file_type_name,
      damage_id: damageId,
      vehicle_defect_resolution_id: damageId,
    }));

    await bindResource({ payload, endPointQuery: `?resource_type=${"defect"}` });
  };

  const tabs = ["Photos", "Videos", "Documents"];

  const imagesFormat = ["png", "jpg", "jpeg"];
  const videosFormat = ["mp4"];
  const documentFormat = ["doc", "docx", "csv", "xlsx", "pdf"];

  const acceptedFiles = activeTab === "Photos" ? imagesFormat : activeTab === "Videos" ? videosFormat : documentFormat;

  const list = fileResourcesState || [];

  const filteredList =
    activeTab === "Photos"
      ? list.filter((f) => imagesFormat.some((e) => f.file_path?.includes(e)))
      : activeTab === "Videos"
      ? list.filter((f) => videosFormat.some((e) => f.file_path?.includes(e)))
      : list.filter((f) => documentFormat.some((e) => f.file_path?.includes(e)));

  return (
    <Wrapper>
      <div className="MainContainer">
        <div className="cardHeader">
          <div className="headerText">Resources</div>
          <HeaderSlider tabs={tabs} setActiveTab={setActiveTab} activeTab={activeTab} />
        </div>

        <FileUpload fileResources={fileResourcesState} setFileResources={setFileResourcesState} acceptedFiles={acceptedFiles} subText="Upload Files" />

        {loading ? (
          <div style={{ padding: "0px 19px" }}>
            <Skeleton active />
          </div>
        ) : filteredList?.length > 0 ? (
          <div style={{ margin: "0 15px 15px 15px" }}>
            <h1>Uploaded Files</h1>
            <FilePreview handleDeleteResource={handleDelete} fileResources={filteredList} />
          </div>
        ) : null}

        <Button onClick={handleSave} loading={bindLoading} className="btn">
          {bindLoading ? "Saving..." : "Save"}
        </Button>
      </div>
    </Wrapper>
  );
};

export default Container;
